import { render, staticRenderFns } from "./VDesignCancelModal.vue?vue&type=template&id=2f39ed5d&"
import script from "./VDesignCancelModal.vue?vue&type=script&lang=ts&"
export * from "./VDesignCancelModal.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignCancelModal.vue?vue&type=style&index=0&id=2f39ed5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports